module.exports = __webpack_public_path__ + "img/amazake_concept_bg.99afdae1.jpg";